<template>
  <!-- container -->
  <div class="containers">
    <!-- section -->
    <Section :topMenu="menu.topMenu[1]"></Section>
    <div class="content_wrap">
      <SideMenu :sideMenu="menu.product" :topMenu="menu.topMenu[1]"></SideMenu>
      <!-- content -->
      <div class="main_content">
        <div class="sub_content">
          <router-view name="changeTab2" :menu="menu.product"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from '@/components/static/SideMenu.vue'
import Section from '@/components/static/Section.vue'
export default {
  name: 'Product',
  data() {
    return {}
  },
  props: {
    menu: Object,
  },
  components: { SideMenu, Section },
  // created() {
  //   console.log(this.menu.product[0].sub)
  // },
}
</script>

<style scoped>
@media (max-width: 960px) {
  .main_content {
    margin-top: 50px;
  }
}
</style>
